import CustomerLogos from './CustomerLogos';

export default CustomerLogos;
